
import {
    Directive,
    Renderer2,
    HostListener,
    ElementRef,
    HostBinding,
    ContentChild,
    Input
} from '@angular/core';
/**
 * 常规Hostlistener监听事件
 */
export class KeyEnterDirective {

     content: any;
/**
 * @param {?} el
 */
constructor(private el: ElementRef) {}
/**
 * @param {?} event
 * @return {?}
 */
keydown(event) {
        var /** @type {?} */ e = event || window.event;
        if (e && e.keyCode == 13) { //回车键的键值为13
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[key-enter]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'content': [{ type: Input, args: ['key-enter', ] },],
'keydown': [{ type: HostListener, args: ['keydown', ['$event'], ] },],
};
}

function KeyEnterDirective_tsickle_Closure_declarations() {
/** @type {?} */
KeyEnterDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
KeyEnterDirective.ctorParameters;
/** @type {?} */
KeyEnterDirective.propDecorators;
/** @type {?} */
KeyEnterDirective.prototype.content;
/** @type {?} */
KeyEnterDirective.prototype.el;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
